import React from "react";
import { Alert } from "@mui/material";
import Header from "../components/Header";

const NewBuildPage = () => (
  <>
    <Header>
      <h1>New Builds</h1>
    </Header>
    <Alert severity="info">Coming Soon!</Alert>
  </>
);

export default NewBuildPage;
